function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.70703 6.33463L5.49674 10.1243L6.48662 9.13445L4.38676 7.03458H10.3888V7.03649C10.4077 7.03607 10.4267 7.03586 10.4457 7.03586C11.8297 7.03586 12.9516 8.15776 12.9516 9.54169C12.9516 10.9256 11.8297 12.0475 10.4457 12.0475C10.4457 12.0475 10.4458 12.0475 10.4457 12.0475L10.4455 12.0463L3.81237 12.0463L3.81237 13.4567H10.4455C12.5765 13.4263 14.2946 11.6891 14.2946 9.55091C14.2946 7.41283 12.5766 5.67601 10.4458 5.64557V5.63468L4.38676 5.63467L6.48662 3.53481L5.49674 2.54492L1.70703 6.33463Z"
});

function SvgArrowReturnLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReturnLeft);
export default __webpack_public_path__ + "static/media/arrow-return-left.4e0fca0c.svg";
export { ForwardRef as ReactComponent };